// Half Past Paradise Theme - JavaScript

document.addEventListener('DOMContentLoaded', function() {
  // Smooth scroll for internal links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  // Product image gallery
  const gallery = document.querySelectorAll('[data-gallery] img');
  if (gallery.length > 1) {
    gallery.forEach((img, idx) => {
      img.style.cursor = 'pointer';
      img.addEventListener('click', function() {
        const mainImg = document.querySelector('[data-main-image]');
        if (mainImg) {
          mainImg.src = this.src;
          mainImg.alt = this.alt;
        }
      });
    });
  }

  // Handle form submissions gracefully
  const forms = document.querySelectorAll('form');
  forms.forEach(form => {
    form.addEventListener('submit', function(e) {
      const submitBtn = this.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.6';
        submitBtn.style.cursor = 'not-allowed';
      }
    });
  });
});
